import { render } from "./B2bFiltersIssues.vue?vue&type=template&id=03a17a7d&scoped=true&lang=pug"
import script from "./B2bFiltersIssues.vue?vue&type=script&lang=js"
export * from "./B2bFiltersIssues.vue?vue&type=script&lang=js"

import "./B2bFiltersIssues.vue?vue&type=style&index=0&id=03a17a7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a17a7d"]])

export default __exports__